<template>
  <div
    class="container flex flex-col justify-between md:justify-start fixed w-full screen overflow-auto bg-white"
    :class="{
      'mt-4 pl-0 pt-0 pr-8': isLoginLayout,
      'container-main pt-5': !isLoginLayout,
      'mt-[48.73px] md:mt-[82px]': theme === 'default',
      'md:mt-0 md:pb-[50px] md:pt-0': theme === 'kids',
    }"
  >
    <!-- Menu basic -->
    <template v-if="!isLanguageMenu">
      <div class="h-full md:pb-6 mt-2">
        <ul
          v-if="$route.name.includes('profile')"
          class="flex flex-col gap-[14px] mb-[1rem] pb-[0.75rem] md:gap-8 xl:gap-6 md:max-w-full text-[18px] text-[#242D21] border-b-2 border-background"
        >
          <li v-for="link in links[theme]" :key="link.routeName">
            <router-link
              :to="{ name: link.routeName }"
              class="group py-[5px] flex justify-between items-center rounded-[0.625rem] md:p-0 md:bg-white"
            >
              <span
                class="text--btn-md xl:group-hover:text-primary-hover xl:group-hover:underline xl:group-active:text-primary-pressed"
                :class="{ 'text-primary': $route.name === link.routeName }"
                >{{ $t(link.title) }}</span
              >
            </router-link>
          </li>
        </ul>
        <div
          v-if="authStore.isLogined"
          class="pb-3 mb-4 border-b-2 border-background flex flex-col items-start"
          :class="{
            'flex justify-between': theme === 'kids',
          }"
        >
          <router-link @click="$emit('close-menu')" :to="{ name: '/profile' }" class="flex items-center">
            <icon-profile class="text-primary w-[32px] h-[32px] mr-2" />
            <span
              class="text--md text-primary"
              :class="{
                uppercase: theme === 'default',
              }"
            >
              {{ authStore.getUser?.userLogin }}
            </span>
          </router-link>
          <button @click="authStore.logout()" class="profile-logout__btn btn--gray-text py-2">
            <IconLogout class="mr-2" />
            {{ $t("common.logout") }}
          </button>
        </div>

        <template v-if="theme === 'default'">
          <h4 class="headline--h4 text-primary mb-4">
            {{ $t("common.catalog") }}
          </h4>

          <MenuCategoryList @close-mobile-menu="$emit('close-menu')" class="md:w-[372px]" />
        </template>
        <template v-else>
          <MenuList @open-partner-form="(type) => $emit('open-partner-form', type)" @close-mobile-menu="$emit('close-menu')" />
        </template>
      </div>

      <MenuActions v-show="theme === 'default'" @open-language-menu="isLanguageMenu = true" class="md:w-[372px]" />
    </template>

    <!-- Language menu -->

    <template v-else>
      <MenuLanguage @close-menu="$emit('close-menu')" class="md:w-[372px]" />
    </template>
  </div>
</template>

<script setup>
import { theme } from "@/services/getSiteTheme"
import { ref } from "vue"

import MenuActions from "./MenuActions.vue"
import MenuLanguage from "./MenuLanguage.vue"
import MenuList from "./MenuList.vue"
import MenuCategoryList from "@/components/header/mobile-menu/MenuCategoryList.vue"
import IconLogout from "components/icons/IconLogout.vue"

import { useAuthStore } from "../../../stores/authStore"
import links from "static/profile-nav"

defineEmits({
  "close-menu": null,
  "open-partner-form": null,
})

defineProps({
  isLoginLayout: {
    type: Boolean,
    default: false,
  },
})

const authStore = useAuthStore()

const isLanguageMenu = ref(false)
</script>

<style lang="scss" scoped>
@import "components/profile/profile-nav/styles/profile";
</style>
